import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/userSlice";
import selectedCityReducer from "./reducers/selectedCitySlice";
import verifyReducer from "./reducers/verifySlice";
import loadingReducer from "./reducers/loadingSlice";
import recentProductSlice from "./reducers/recentProduct";
import conversationIdSlice from "./reducers/conversationIdSlice";
import chatRoleSlice from "./reducers/chatRoleSlice";
import chatSlice from "./reducers/chatSlice";
import messagesSlice from "./reducers/messagesSlice";
import sendingSlice from "./reducers/sendingSlice";
import responsiveHandleSlice from "./reducers/responsiveHandle";

export default configureStore({
  reducer: {
    user: userReducer,
    selectedCity: selectedCityReducer,
    verify: verifyReducer,
    loading: loadingReducer,
    recentProducts: recentProductSlice,
    conversationId: conversationIdSlice,
    chatRole: chatRoleSlice,
    showChat: chatSlice,
    messages: messagesSlice,
    sendingStatus: sendingSlice,
    responsiveHandle: responsiveHandleSlice,
  },
});
